import * as Yup from 'yup';

export default Yup.object().shape({
  type: Yup.string()
    .required('La tipologia dell\'immobile è richiesta'),
  address: Yup.string()
    .required('L\'indirizzo dell\'immobile è richiesto'),
  floor: Yup.string(),
  size: Yup.number()
    .min(0, 'La dimensione deve essere maggiore di zero')
    .max(10000, 'La dimensione massima consentita è 10000')
    .required('I mq dell\'immobile sono richiesti'),
  status: Yup.string(),
});
